var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallGov = function SvgSmallGov(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.05 61.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 44.52c8.38-.58 17.91-1.09 27.28-1.24 9.6-.15 19.32.15 27.77.59M55.43 61H.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.83 43.94 13.94-11.41V18.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.16 43.51 7.36-10.98V16.5M36.64 43.28l-7.59-10.54V16.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.92 43.43 31.79 31.89V18.82M27.78 24.72V1.31S30.52 0 31.58.68A4.7 4.7 0 0 0 35 1.1v4a5.27 5.27 0 0 1-3.37-.43c-1.27-.84-3.8.64-3.8.64M1.05 61V44.48M5.57 61V44.19M10.04 61V43.83M14.71 61V43.7M25.25 50.45V61M30.95 50.45V61M36.64 61V50.45H19.35V61M41.09 43.33V61M45.81 43.43V61M50.43 43.63V61M55.05 61V43.83"
  }))));
};
export default SvgSmallGov;